import { Injectable } from '@angular/core';
import { StorageService } from 'src/app/services/storage.service';


@Injectable({
    providedIn: 'root'
  })
  export class AppConfigService {

    constructor(private storageService: StorageService) { }

    getIsGracePayment(): boolean {
      return this.storageService.getIsGracePayment() ?? false;
    }
    
   setIsGracePayment(value: boolean): void {
      this.storageService.setIsGracePayment(value);
    }

  }
  